import Repository from './Repository'

const resource = 'lessons'

export default {
  getLessons () {
    return Repository.get(`${resource}`)
  },
  getLesson (lessonId, params) {
    return Repository.get(`${resource}/${lessonId}`, params)
  }
}
